// frontend/src/services/metaApi.ts
// Public (no-auth) metadata endpoint wrapper. Session-level cache:
// the practice-area list doesn't change within a page load, and
// re-fetching on every screen that renders labels would be wasteful.
import api from './api';
import type { PracticeArea } from '../types/practiceArea';

export interface PracticeAreaOption {
  value: PracticeArea;
  label: string;
}

let cached: PracticeAreaOption[] | null = null;

export async function getPracticeAreas(): Promise<PracticeAreaOption[]> {
  if (cached) return cached;
  const { data } = await api.get<PracticeAreaOption[]>('/meta/practice-areas');
  cached = data;
  return data;
}

/** Resets the module-level cache. Call on logout (or in tests). */
export function _resetPracticeAreasCache(): void {
  cached = null;
}
